/***************************************************************************************************
 *
 * This file defines the Redux slice for managing quotations within the application.
 * 
 * It provides:
 * 
 * 1. Async actions to create, update, and fetch quotations.
 * 2. A reducer to handle state changes related to quotation data and API responses.
 * 3. Initial state setup for storing quotation data.
 * 
***************************************************************************************************/


import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { getQuotations } from 'src/_helpers/api'

const name = 'quotations'

const initialState = createInitialState()

const getAllQuotationsAsync = createAsyncThunk(`${name}/get-quotations`, async () => {
	const response = await getQuotations()
	//console.log('🚀 ~ returncreateAsyncThunk ~ response:', response)
	return response
})

const quotationSlice = createSlice({
	name,
	initialState: createInitialState(), 
	reducers: {
		resetState: (state) => {
			state.quotations = [];
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllQuotationsAsync.pending, (state) => {
				state.error = null
			})
			.addCase(getAllQuotationsAsync.fulfilled, (state, action) => {
				state.quotations = action.payload
			})
			.addCase(getAllQuotationsAsync.rejected, (state, action) => {
				state.error = action.error
			})
	},
})

function createInitialState() {
	return {
		quotations: [],
	}
}

export const quotationActions = {
	...quotationSlice.actions,
	getAllQuotationsAsync,
	resetState: quotationSlice.actions.resetState,}

export const quotationsReducer = quotationSlice.reducer
